import {
  Container,
  Center,
  Loader,
  TextInput,
  Title,
  Paper,
  Button,
  Avatar,
  Text,
  Group,
  Stack,
} from "@mantine/core";
import { useEffect } from "react";
import { useForm } from "@mantine/form";
import { getProfile, updateProfile } from "../api";
import { useStore } from "../store";
import ImageUploader from "./ImageUploader";
import { notifications } from "@mantine/notifications";

export default function ProfileEdit() {
  const profile = useStore((state) => state.profile);
  const setProfile = useStore((state) => state.setProfile);

  const form = useForm({
    mode: "uncontrolled",
  });

  // const form = useForm({
  //   initialValues: {
  //     name: "",
  //   },
  //   // validate: {
  //   //   // name: (val) => (/^[a-zA-Z0-9_-]{1, 22}$/.test(val) ? null : "Invalid plan name")
  //   // },
  // });

  useEffect(() => {
    getProfile().then((data) => {
      form.setValues(data);
      setProfile(data);
    });
    // Mantine form object has unstable identity; including it would rerun this effect every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateProfileHandler = (data) => {
    updateProfile(data).then(() => {
      notifications.show({
        color: "green",
        autoClose: 4000,
        title: "Changes saved",
        message: "Your profile changes have been saved",
      });
    });
  };

  if (!profile)
    return (
      <Container size="sm">
        <Center>
          <Loader />
        </Center>
      </Container>
    );

  return (
    <Container size="sm">
      <Title order={1}>Profile</Title>

      {/* <BackgroundImage src={profile.backgroundImage} radius="md">
        <ImageUploader message={profile.backgroundImage ? "" : "Upload a header image"} imageType="background" onProfileUpdated={(data) => setProfile(data)} />
      </BackgroundImage>
*/}
      <ImageUploader
        image={
          <Avatar
            src={profile.profileImageUrl}
            size={120}
            radius={120}
            mx="auto"
          />
        }
        message="Upload a portrait"
        imageType="profile"
        onProfileUpdated={(data) => setProfile(data)}
      />

      <Paper mt="md" p="md">
        <Text fz="xl" fw={500}>
          Personal Settings
        </Text>
        <form onSubmit={form.onSubmit(updateProfileHandler)}>
          <Stack>
            <TextInput
              {...form.getInputProps("firstName")}
              key={form.key("firstName")}
              label="First Name"
            />
            <TextInput
              {...form.getInputProps("lastName")}
              key={form.key("lastName")}
              label="Last Name"
            />
            <TextInput
              {...form.getInputProps("emailAddress")}
              key={form.key("emailAddress")}
              label="Email"
            />

            <Text>Role: {profile.userRole}</Text>

            <Group justify="flex-end">
              <Button mt="lg" type="submit">
                Save
              </Button>
            </Group>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
